'use client';

import React from 'react';
import { useTranslations } from 'next-intl';

interface ChangeSettingsReminderProps {
  className?: string;
}

export default function ChangeSettingsReminder({ className = '' }: ChangeSettingsReminderProps) {
  const tForm = useTranslations('Form');

  return <p className={`text-sm text-muted-foreground ${className}`}>{tForm('preferences.changeSettingsReminderPrefix')}.</p>;
}
